// extracted by mini-css-extract-plugin
export default {"map":"map_map__nugye"};